import { Box, Text } from '@/ui/primitives';
import type { ReactElement } from 'react';

type TestingChangedSectionProps = {
  width: number;
};

export const TestingChangedSection = ({ width }: TestingChangedSectionProps): ReactElement => (
  <Box component="section">
    <Box sx={{ maxWidth: width, mx: 'auto' }}>
      <Text role="sectionTitle" component="h2" transform="none" mb="lg">
        Understanding quality is more challenging than ever.
      </Text>
      <Text role="bodyMuted" component="p" mb="md">
        AI has supercharged how we build, test, and deliver.
      </Text>
      <Text role="bodyMuted" component="p" mb="md">
        Teams struggle to keep up with increased output without compromising quality.
      </Text>
      <Text role="bodyMuted" component="p" mb="md">
        Higher throughput brings noisy signals, time lost maintaining outdated spreadsheets,
        constantly editing reports, and trawling through unfriendly build logs and artefacts.
      </Text>
      <Text role="bodyMuted" component="p" mb="xl">
        This pulls focus away from catching issues early, improving tests, and reducing lead time.
      </Text>
      <Text role="sectionTitle" component="h2" transform="none" mb="xl">
        FlowQA is built to solve this.
      </Text>
      <Text role="bodyMuted" component="p" mb="md">
        An unobtrusive layer that sits alongside existing workflows, turning raw test output into a
        continuously updated view of quality - without changing how you run tests.
      </Text>
    </Box>
  </Box>
);
